import { useMemo } from "react";
import { useAuth } from "react-oidc-context";

import { type Authority, resolveAccess, type ResolvedAccess } from "./authorities";

export interface Access extends ResolvedAccess {
  email: string;
  can: (authority: Authority) => boolean;
}

/**
 * The signed-in operator's identity and authorities, from the ID token.
 *
 * The ID token is what the console sends (see api/client.ts) and it carries
 * `email` and `cognito:groups` natively.
 */
export function useAccess(): Access {
  const auth = useAuth();
  const claims = auth.user?.profile as Record<string, unknown> | undefined;

  return useMemo(() => {
    const groups = claims?.["cognito:groups"] as string[] | undefined;
    const resolved = resolveAccess(groups);
    return {
      ...resolved,
      email: String(claims?.email ?? ""),
      can: (a: Authority) => resolved.authorities.has(a),
    };
  }, [claims]);
}
